import fomApi from '../../../../services/fomApi';
export function load(){
    return async function(dispatch){
        const locations = await fomApi.getLocations();
        const action = { type : 'LOCATION_INIT', payload : locations}
        dispatch(action);
    }
}

